export function calculateAge (dob: Date) {
    var diff_ms = Date.now() - dob.getTime()
    var age_dt = new Date(diff_ms)
    return Math.abs(age_dt. getUTCFullYear() - 1970)
}

export function formatDate (year, month, date) {
    const d = new Date(year, month, date)
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
    const mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d)
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)

    return `${da} ${mo}, ${ye}`
}